import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

// Define initial data points
let currencies = [];
let currencyDefinitions = [];
let initialized = false;

// Extend CurrencyStore with EventEmitter to add eventing capabilities
class CurrencyStore extends FluxStore {
	getIsInitialized() {
		return initialized;
	}

	getCurrencies() {
		return currencies;
	}

	getCurrency(currencyId) {
		return currencies.find(c => c.id === currencyId);
	}

	getCurrencyDefinitions() {
		return currencyDefinitions;
	}

	getCurrencyDefinitionByCurrencyId(currencyId) {
		const currency = this.getCurrency(currencyId);

		if (currency) {
			return currencyDefinitions.find(cd => cd.id === currency.currencyDefinitionId);
		}

		return null;
	}
}

const currencyStore = new CurrencyStore();

currencyStore.dispatchToken = AppDispatcher.register((action) => {
	let index = -1;
	switch (action.actionType) {
		case AppConstants.CURRENCY_INITIALIZE:
			initialized = true;
			currencies = action.currencies;
			currencyDefinitions = action.currencyDefinitions;
			break;

		case AppConstants.CURRENCYSTORE_SAVE_SUCCESS:
			index = currencies.map(c => c.id).indexOf(action.currency.id);
			if (index !== -1) {
				currencies[index] = action.currency;
			}
			else {
				index = currencies.length;
				currencies.push(action.currency);
			}
			break;

		case AppConstants.CURRENCYSTORE_DELETE_SUCCESS:
			index = currencies.map(c => c.id).indexOf(action.currencyId);
			if (index !== -1) {
				currencies.splice(index, 1);
			}
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	currencyStore.emitChange();
	return true;
});

export default currencyStore;



// WEBPACK FOOTER //
// ./Components/stores/CurrencyStore.jsx